module.exports = __webpack_public_path__ + "a48d46002f1850417dedfbb631c921e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Front_1-2-optimized.jpg
// module id = 77
// module chunks = 0